import { useEffect, useState } from 'react'

export const useMediaQuery = (query: string): boolean => {
    const [state, setState] = useState(() => ({ query, matches: window.matchMedia(query).matches }))

    if (state.query !== query) {
        setState({ query, matches: window.matchMedia(query).matches })
    }

    useEffect(() => {
        const mediaQueryList = window.matchMedia(query)
        const handleChange = (event: MediaQueryListEvent): void => setState({ query, matches: event.matches })

        mediaQueryList.addEventListener('change', handleChange)

        return () => mediaQueryList.removeEventListener('change', handleChange)
    }, [query])

    return state.matches
}
